import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material';

import { ChevronLeftOutlined } from '@mui/icons-material';

import { labOrdersDialogStyles } from './LabOrdersDialogStyles';
import { clickableTableRowSx } from '../../../Common/components/Styles/InputStyles';

const defaultDiagnoses = [
  {
    id: 1,
    code: 'A37.90',
    description: 'Pertussis'
  },
  {
    id: 2,
    code: 'A49.02',
    description: 'MSSA Bacteremia'
  },
  {
    id: 3,
    code: 'A49.03',
    description: 'Unspecified Sexually Transmitted Disease'
  },
  {
    id: 4,
    code: 'D64.9',
    description: 'Anemia, Unspecified'
  },
  {
    id: 5,
    code: 'E039',
    description: 'Hypothyroidism'
  }
];

const PastDiag = ({ diagnoses, onSelect }) => {
  const handleSelectDiagnosis = diagnosis => {
    onSelect(diagnosis);
  };

  return (
    <Box sx={labOrdersDialogStyles.pastDiagnosisPanel}>
      <Box sx={labOrdersDialogStyles.panelHeader}>
        <Typography sx={labOrdersDialogStyles.panelTitle}>
          Past Diagnosis
        </Typography>
      </Box>

      <TableContainer sx={labOrdersDialogStyles.tableContainer}>
        <Table sx={labOrdersDialogStyles.diagnosisTable}>
          <TableBody>
            {diagnoses.map(diagnosis => (
              <TableRow
                key={diagnosis.id}
                hover
                tabIndex={0}
                role="button"
                onClick={() => handleSelectDiagnosis(diagnosis)}
                onKeyDown={event => {
                  if (
                    event.key === 'Enter' ||
                    event.key === ' '
                  ) {
                    event.preventDefault();
                    handleSelectDiagnosis(diagnosis);
                  }
                }}
                sx={clickableTableRowSx}
              >
                <TableCell
                  sx={labOrdersDialogStyles.actionCell}
                >
                  <IconButton
                    size="small"
                    disableRipple
                    disableFocusRipple
                    aria-label={`Select ${diagnosis.description}`}
                    onClick={event => {
                      event.stopPropagation();
                      handleSelectDiagnosis(diagnosis);
                    }}
                    sx={labOrdersDialogStyles.selectButton}
                  >
                    <ChevronLeftOutlined
                      sx={labOrdersDialogStyles.selectIcon}
                    />
                  </IconButton>
                </TableCell>

                <TableCell
                  sx={labOrdersDialogStyles.codeCell}
                >
                  {diagnosis.code}
                </TableCell>

                <TableCell
                  sx={labOrdersDialogStyles.diagnosisCell}
                >
                  <Typography
                    sx={labOrdersDialogStyles.diagnosisText}
                  >
                    {diagnosis.description}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

PastDiag.propTypes = {
  diagnoses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ),
  selectedDiagnosisIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  onSelect: PropTypes.func
};

PastDiag.defaultProps = {
  diagnoses: defaultDiagnoses,
  selectedDiagnosisIds: [],
  onSelect: () => {}
};

export default PastDiag;
